var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.971191,
    width: 30,
    height: 30,
    rx: 8,
    fill: "black",
    fillOpacity: 0.85
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.47119 15C8.47119 12.0041 8.47119 10.5061 9.1851 9.42713C9.5039 8.94532 9.91652 8.53271 10.3983 8.21391C11.4773 7.5 12.9752 7.5 15.9712 7.5C18.9671 7.5 20.4651 7.5 21.5441 8.21391C22.0259 8.53271 22.4385 8.94532 22.7573 9.42713C23.4712 10.5061 23.4712 12.0041 23.4712 15C23.4712 17.9959 23.4712 19.4939 22.7573 20.5729C22.4385 21.0547 22.0259 21.4673 21.5441 21.7861C20.4651 22.5 18.9671 22.5 15.9712 22.5C12.9752 22.5 11.4773 22.5 10.3983 21.7861C9.91652 21.4673 9.5039 21.0547 9.1851 20.5729C8.47119 19.4939 8.47119 17.9959 8.47119 15ZM19.8539 15.0002C19.8539 17.1446 18.1155 18.883 15.9711 18.883C13.8266 18.883 12.0882 17.1446 12.0882 15.0002C12.0882 12.8558 13.8266 11.1173 15.9711 11.1173C18.1155 11.1173 19.8539 12.8558 19.8539 15.0002ZM15.9711 17.5694C17.39 17.5694 18.5402 16.4191 18.5402 15.0002C18.5402 13.5813 17.39 12.431 15.9711 12.431C14.5521 12.431 13.4019 13.5813 13.4019 15.0002C13.4019 16.4191 14.5521 17.5694 15.9711 17.5694ZM20.0073 11.8346C20.5111 11.8346 20.9196 11.4261 20.9196 10.9223C20.9196 10.4184 20.5111 10.0099 20.0073 10.0099C19.5034 10.0099 19.0949 10.4184 19.0949 10.9223C19.0949 11.4261 19.5034 11.8346 20.0073 11.8346Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInstagram);
export default __webpack_public_path__ + "static/media/ic_instagram.29742a60.svg";
export { ForwardRef as ReactComponent };